import {
  AGENT_JUDGE_CATEGORICAL_MANAGER,
  AGENT_JUDGE_MANAGER,
  AGENT_JUDGE_NUMERICAL_MANAGER,
} from "../configuration/optimization/constants"

export const METRIC_MANAGERS = {
  manager_llm_binary: "manager_llm_binary",
  manager_audio_llm_binary: "manager_audio_llm_binary",
  manager_agent_fails_to_respond: "manager_agent_fails_to_respond",
  manager_agent_needs_reprompting: "manager_agent_needs_reprompting",
  manager_agent_repeats_itself: "manager_agent_repeats_itself",
  manager_transcript_regex_match: "manager_transcript_regex_match",
  manager_user_frustration: "manager_user_frustration",
  manager_agent_refusal: "manager_agent_refusal",
  manager_words_per_message_with_threshold:
    "manager_words_per_message_with_threshold",
  manager_audio_llm_categorical: "manager_audio_llm_categorical",
  manager_default_categorical: "manager_default_categorical",
  manager_derived_strict_logic: "manager_derived_strict_logic",
  manager_end_reason: "manager_end_reason",
  manager_llm_text: "manager_llm_text",
  manager_sentimentanalysis: "manager_sentimentanalysis",
  manager_match_expected_sim_wrapper: "manager_match_expected_sim_wrapper",
  manager_audio_llm_numerical: "manager_audio_llm_numerical",
  interruption_rate_manager: "interruption_rate_manager",
  manager_persona_interruption_rate: "manager_persona_interruption_rate",
  manager_latency: "manager_latency",
  manager_persona_latency: "manager_persona_latency",
  manager_numerical_llm_judge: "manager_numerical_llm_judge",
  manager_signal_to_noise_ratio: "manager_signal_to_noise_ratio",
  manager_time_to_first_audio: "manager_time_to_first_audio",
  manager_transcription_error: "manager_transcription_error",
  manager_words_per_message: "manager_words_per_message",
  manager_abrupt_pitch_changes: "manager_abrupt_pitch_changes",
  manager_pitch_variability: "manager_pitch_variability",
  manager_lufs: "manager_lufs",
  manager_terminal_contour: "manager_terminal_contour",
  audio_duration_metric_manager: "audio_duration_metric_manager",
  manager_audio_frequency: "manager_audio_frequency",
  manager_clipping_artifact: "manager_clipping_artifact",
  manager_codec_artifact: "manager_codec_artifact",
  manager_persona_clipping_artifact: "manager_persona_clipping_artifact",
  manager_persona_codec_artifact: "manager_persona_codec_artifact",
  manager_dropout_artifact: "manager_dropout_artifact",
  manager_non_expressive_pauses: "manager_non_expressive_pauses",
  manager_persona_non_expressive_pauses:
    "manager_persona_non_expressive_pauses",
  pause_analysis_metric: "pause_analysis_metric",
  manager_phonemes_per_second: "manager_phonemes_per_second",
  manager_phoneme_stretch: "manager_phoneme_stretch",
  manager_persona_phoneme_stretch: "manager_persona_phoneme_stretch",
  manager_spectrogram_pitch_analysis: "manager_spectrogram_pitch_analysis",
  manager_vocal_fry: "manager_vocal_fry",
  manager_volume_pitch_misalignment: "manager_volume_pitch_misalignment",
  manager_volume: "manager_volume",
  manager_loop_detection: "manager_loop_detection",
  manager_music_detection: "manager_music_detection",
  manager_persona_volume_pitch_misalignment:
    "manager_persona_volume_pitch_misalignment",
  manager_persona_volume: "manager_persona_volume",
  manager_persona_loop_detection: "manager_persona_loop_detection",
  manager_persona_music_detection: "manager_persona_music_detection",
  manager_syllable_rate: "manager_syllable_rate",
  manager_voice_quality: "manager_voice_quality",
  manager_timbre_drift: "manager_timbre_drift",
  manager_speech_artifact_anomaly: "manager_speech_artifact_anomaly",
  manager_speaking_time_percentage: "manager_speaking_time_percentage",
  manager_audio_sentiment: "manager_audio_sentiment",
  manager_api_state: "manager_api_state",
  manager_composite_evaluation: "manager_composite_evaluation",
  manager_metadata_field_metric: "manager_metadata_field_metric",
  manager_custom_trace: "manager_custom_trace",
  manager_sql_float: "manager_sql_float",
  manager_python: "manager_python",
  manager_derived_aggregate: "manager_derived_aggregate",
  manager_rubric_decision_tree: "manager_rubric_decision_tree",
  manager_ivr_flow_adherence: "manager_ivr_flow_adherence",
  manager_custom_audio_frequency: "manager_custom_audio_frequency",
  manager_custom_end_reason: "manager_custom_end_reason",
  manager_custom_agent_needs_reprompting:
    "manager_custom_agent_needs_reprompting",
  manager_custom_audio_sentiment: "manager_custom_audio_sentiment",
  manager_custom_agent_fails_to_respond:
    "manager_custom_agent_fails_to_respond",
  manager_agentic_llm_judge: AGENT_JUDGE_MANAGER,
  manager_agentic_llm_judge_categorical: AGENT_JUDGE_CATEGORICAL_MANAGER,
  manager_agentic_llm_judge_numerical: AGENT_JUDGE_NUMERICAL_MANAGER,
} as const
